:host {
  display: block;
  max-width: 100%;
}

.content-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;

  .form-wrapper {
    width: 100%;
    height: auto;

    #email-verification-disclaimer {
      color: var(--grey-layout-202-disabled-icons);
      padding-bottom: calc(var(--spacer));
      width: 480px;
    }

    #email-address-mini-form {
      &:not([hasSendButtonBelowEmail]) {
        display: flex;
        flex-direction: row;
        margin-bottom: calc(var(--spacer));

        #send-verification-code-button {
          padding-top: 4px;
          padding-left: calc(var(--spacer));
          height: 100%;
        }
      }

      &[hasSendButtonBelowEmail] {
        display: flex;
        flex-direction: column;
        width: 240px;

        #send-verification-code-button-wrapper {
          display: flex;
          flex-direction: row;
          justify-content: flex-end;
        }
      }
    }

    #email-verification-disclaimer[highlight] {
      color: var(--chart-300-icon-buttons);
    }

    #has-verified-email-address-form-field {
      display: none;
    }

    #verification-code-form-field {
      margin-bottom: calc(var(--spacer));
    }
  }

  #clear-data-button {
    width: auto;
    margin-right: auto;
  }
}
